module.exports = __webpack_public_path__ + "img/item3.bccb5ba1.png";